// @flow

import React, { createElement, PureComponent } from 'react';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import colors from '../config/colors';
import settings from '../config/settings';

import Nav from './Nav';
import NavHeader from './NavHeader';

import baartLogo from '../images/baart-logo.svg';
import dots from '../images/dots.svg';

const SidebarWrapper = styled.aside`
  background: ${colors.sidebar.bg};
  bottom: 0;
  color: ${colors.sidebar.color};
  font-size: 15px;
  height: 100%;
  left: ${props => props.navRevealed ? settings.navSize : '100%'};
  padding: 1em;
  position: fixed;
  right: 0;
  transition: 350ms linear box-shadow;
  text-align: center;
  top: 0;
  width: calc(100% - ${settings.navSize});
  z-index: 2;

  ${props => props.navRevealed && css`
    box-shadow: -1px 0 3px rgba(0, 0, 0, 0.25);
  `}

  ${settings.navTransition && css`transition: ${settings.navTransition}, 350ms linear box-shadow;`}

  > img {
    bottom : 2em;
    left: calc(50% - 26px);
    pointer-events: none;
    position: absolute;
  }

  @media (min-width: 375px) {
    font-size: 16px;
  }
`;

const activeClassName = 'active';
const NavItem = styled(NavLink).attrs({ activeClassName })`
  &.${activeClassName} {
    background-color: #555555;
    color: #FFFFFF;
  }
`;

const image = createElement('img', { src: baartLogo, width: 80, height: 'auto' }, null);

const nav = [
  {
    links: [
      { title: 'Home', image: image, to: '/', exact: true }
    ]
  },
  {
    title: 'Tools',
    links: [
      { title: 'Vortex Shaft Mount Calculator', to: '/tools/vortex', exact: false }
    ]
  },
  {
    title: 'Company',
    links: [
      { title: 'About Us', to: '/about', exact: true },
      { title: 'Contact Us', to: '/contact', exact: true },
      { title: 'Support', to: '/support', exact: true }
    ]
  }
];

type Props = {
  navRevealed: boolean,
  navSelected: () => void
}

class Sidebar extends PureComponent<Props> {

  navClicked = () => {
    this.props.navSelected();
  }

  render() {
    let navigation = [];

    nav.forEach((item, index) => {
      // Add nav header if present
      if (item.title) {
        navigation.push(<NavHeader key={`nav-header-${index}`} title={item.title} />);
      }
      // Build the links
      navigation.push(
        <Nav key={`nav-${index}`} navBlock>
          {
            item.links.map((link, index) => (
              <li key={`nav-li-${index}`}>
                <NavItem {...link} onClick={this.navClicked}>
                  {link.image ? link.image : link.title}
                </NavItem>
              </li>
            ))
          }
        </Nav>
      );
    });
    // Render the sidebar
    return (
      <SidebarWrapper navRevealed={this.props.navRevealed || false}>
        {navigation}
        <img src={dots} alt="" width="52" height="10" />
      </SidebarWrapper>
    );
  }

};

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar.js